import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import api from '../../../api';

const Facilities = () => {
    const { campus_slug } = useParams();
    const [facilities, setFacilities] = useState({
        loading: true,
        error: null,
        data: [],
    });

    // Track expanded states for each facility
    const [expanded, setExpanded] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await api.get(`/api/campus/${campus_slug}/facilities`);
                if (res.data.status) {
                    setFacilities({
                        loading: false,
                        error: null,
                        data: res.data.data
                    });
                } else {
                    setFacilities(prev => ({
                        ...prev,
                        loading: false,
                        error: res.data.message
                    }));
                }
            } catch (err) {
                setFacilities(prev => ({
                    ...prev,
                    loading: false,
                    error: err.response?.data?.message || 'Failed to fetch facilities',
                }));
            }
        };

        fetchData();
    }, [campus_slug]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: facilities.data.length < 3 ? facilities.data.length : 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 1} },
            { breakpoint: 480, settings: { slidesToShow: 1 } },
        ]
    };

    // Toggle "View More" / "View Less"
    const toggleExpand = (index) => {
        setExpanded(prev => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    if (facilities.loading || facilities.error || facilities.data.length === 0) {
        return <></>;
    }

    return (
        <section className="facility_detail_section pb_80">
            <div className="container ">
                    <div className="sec-title text-center">
                  <h2>Explore Our Campus</h2>
                </div>
                

                <Slider {...settings} className="facility-carousel">
                    {facilities.data.map((facility, index) => {
                        const text = facility.text || '';
                        const isExpanded = expanded[index];
                        const needsExpandButton = text.length > 150;

                        return (
                            <div key={index} >
                                <div
                                    className={`card card_fac wow fadeIn ${isExpanded ? 'expanded' : ''}`}
                                    data-wow-duration="2s"
                                    data-wow-delay={`${0.2 * (index % 3)}s`}
                                >
                                    {facility.image && (
                                        <div className='campus-facility-image-wrapper'>
                                            <img src={facility.image} alt={facility.title} />
                                        </div>
                                    )}
                                    <div className="card-body card_fac_body">
                                        <h5 className="card-title card_fac_title">{facility.title}</h5>
                                      <p className={`card-text card_fac_text ${isExpanded ? 'expanded' : ''}`}>
    {text}
</p>

                                        {needsExpandButton && (
                                            <button
                                                onClick={() => toggleExpand(index)}
                                                className="campus-view-button align-items-center d-flex justify-content-center mt-3 w-100"
                                                style={{
                                                    color: 'var(--thm-bg)',
                                                    cursor: 'pointer',
                                                    border: 'none',
                                                    background: 'none',
                                                    padding: '5px',
                                                    fontWeight:'700'
                                                }}
                                            >
                                                {isExpanded ? 'View Less' : 'View More'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </section>
    );
};

export default Facilities;